import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'Amarillas-lang',
  templateUrl: './lang.component.html',
  styleUrls: ['./lang.component.scss'],
})
export class LangComponent implements OnInit {
  @Input() langages: any[] = [];
  constructor(
    private popoverController: PopoverController
  ) { }

  ngOnInit() {}

  changeLang( item ){
    this.popoverController.dismiss(item)
  }

}
